module.exports = __webpack_public_path__ + "img/花草_04.4967d3aa.png";